export default __webpack_public_path__ + "static/600px-Silver-Sparkles-34b27e7213855afc7f18677abf5587bd.png";